export default __webpack_public_path__ + "static/media/doubt solution.b6ad0905.svg";